"use strict";
/**
 * iCure Data Stack API Documentation
 * The iCure Data Stack Application API is the native interface to iCure. This version is obsolete, please use v2.
 *
 * OpenAPI spec version: v1
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.Telecom = void 0;
/**
 * This entity represents available contact details of a user, reachable by telecom methods
 */
class Telecom {
    constructor(json) {
        Object.assign(this, json);
    }
}
exports.Telecom = Telecom;
(function (Telecom) {
    Telecom.TelecomTypeEnum = {
        Mobile: 'mobile',
        Phone: 'phone',
        Email: 'email',
        Fax: 'fax',
        Skype: 'skype',
        Im: 'im',
        Medibridge: 'medibridge',
        Ehealthbox: 'ehealthbox',
        Apicrypt: 'apicrypt',
        Web: 'web',
        Print: 'print',
        Disk: 'disk',
        Other: 'other',
    };
})(Telecom = exports.Telecom || (exports.Telecom = {}));
//# sourceMappingURL=Telecom.js.map